import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import ServicesOverview from './components/ServicesOverview';
import WeeklyPA from './components/WeeklyPA';
import BusinessSupport from './components/BusinessSupport';
import CalendarBooking from './components/CalendarBooking';
import Footer from './components/Footer';
import StickyWhatsApp from './components/StickyWhatsApp';

function App() {
  return (
    <div>
      <Hero />
      <About />
      <HowItWorks />
      <ServicesOverview />
      <WeeklyPA />
      <BusinessSupport />
      <CalendarBooking />
      <Footer />
      <StickyWhatsApp />
    </div>
  );
}

export default App;
